import { Caches } from "@/lib/caches"
import { consumeContext } from "@/lib/consume/context"

export const consumeCaching = consumeContext({
  Context: Caches.Context,
  provideTo: `caching`,
})
